import {Link} from 'react-router-dom';
import React from 'react';

import {useracc, putApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import './css/contact.css';

export default class Contact extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			show: 'contact',
      name: '',
			email: '',
			message: '',
		};
		this.handleChange = this.handleChange.bind(this);
		this.processDetails = this.processDetails.bind(this);
  };

  
  
  async componentDidMount() {
		document.title = "Contact - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
		this.setState({status: true});
	}

	componentWillUnmount() {
	}

	handleChange(event) {
		//var isChecked = event.target.checked;
		var item = event.target.value;
		if( event.target.name === "name" ) this.setState({name:item});
		if( event.target.name === "email" ) this.setState({email:item});
		if( event.target.name === "message" ) this.setState({message:item});
	}

	async processDetails(event) {
		event.preventDefault();
		this.setState({show: 'complete'});

		const params = new URLSearchParams();
		params.append('name', this.state.name);
		params.append('email', this.state.email);
		params.append('message', this.state.message);

		await putApi('/api/v2/contact', params);
		

	}
	

	render() {
		
		return (
			<>
				{this.state.status &&
					<>
						<div className="contact">
							<div className="contact-background"></div>
						</div>
						

						
						{/*<div className="website-background"></div>*/}
						<div className="article">

							<Row className="gx-0">
								<Col className="contact-header">
									<h1>contact us</h1>
								</Col>
							</Row>

							<Row className="gx-0">
								<Col md={{span: 6, offset: 2}} >
								
									<h3>You can</h3>
									<h2>contact us</h2>

									<p>We would love to hear from you. We welcome all comments and suggestions.</p>

									<p>If you are interested or looking to apply for DJ position here on mix365, please <Link to="/apply">click here</Link> to apply instead</p>

									{this.state.show==='contact' ?
										<>
											

											<Form id="contact-form" onSubmit={this.processDetails}>
												
													<InputGroup className="mb-2">
														<FormControl name="name" id="name" onChange={this.handleChange} value={this.state.name} placeholder="Name" aria-label="Name" aria-describedby="basic-addon1" required />
													</InputGroup>
													<InputGroup className="mb-2">
														<FormControl name="email" id="email" onChange={this.handleChange} value={this.state.email} placeholder="Email" aria-label="Email" aria-describedby="basic-addon1" required />
													</InputGroup>

													<InputGroup className="mb-2">
														<Form.Control as="textarea" rows="6" name="message" id="message" onChange={this.handleChange} value={this.state.message} placeholder="Message" aria-label="Message" aria-describedby="basic-addon1" required />
													</InputGroup>

												
												

												
													<Button onClick={this.processDetails} size="sm">Send message</Button>
												
											</Form>
										</>
									:
										<>
											<p>Thank you for contacting support and we will get back to you as soon as possible</p>
											<p>Contact Details:</p>
											<p>Name: {this.state.name}</p>
											<p>Email: {this.state.email}</p>
											<p>Message: {this.state.message}</p>
										</>
									}

								</Col>

							</Row>


							<Row className="py-5">
								<Col className="text-center">
								
									<ul className="home-followus">
										<li>
											<a href="https://www.facebook.com/groups/mix365" title="Facebook" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" /> Facebook
											</a>
										</li>
										<li>
											<a href="https://www.instagram.com/mix365radio/" title="Instagram" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" /> Instagram
											</a>
										</li>
										<li>
											<a href="https://twitter.com/Mix365R" title="Twitter" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'twitter']} className="header-socials" /> Twitter
											</a>
										</li>
										<li>
											<a href="https://discord.gg/DtRYeVPJ5J" title="Discord" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'discord']} className="header-socials" /> Discord
											</a>
										</li>
									</ul>

								</Col>
							</Row>
						</div>
					</>
				}
			</>
		);
	}
}
